import HttpClient from "../services/HttpClient";
import {
  ERROR_MESSAGE,
  APP_URL_CONTRACT,
  APP_URL_REQUEST_MANAGEMENT,
} from "../constants";

export const getEmployeeData = (document, documentType, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(
      `${APP_URL_CONTRACT}/employee/by-document/${documentType}/${document}`,

      headers
    )
      .then((response) => {
        if (response.data.result) {
          resolve(response);
        }
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getEmployeeDataContract = (document, documentType, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(
      `${APP_URL_CONTRACT}/contract/active/by-document/${documentType}/${document}`, headers
    )
      .then((response) => {
        if (response.data.result) {
          resolve(response);
        }
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

/* export const getUserByDocument = (document) => {
  const headers = {'Content-Type': 'application/json'};
  return new Promise((resolve) => {
    HttpClient.post(`${APP_URL}${USERBYDOCUMENT}`,document, headers).then((response) => {
      resolve(response);
    }).catch((error) => {
      resolve(error?.response);
    })
  })
} */

export const createPermissions = (data) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(`${APP_URL_REQUEST_MANAGEMENT}/request-management/`, data, headers).then((response) => {
        resolve(response);
      }).catch((error) => {
        resolve(error.response);
      });
  });
};

export const permissionsCriteria = (filters, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(
      `${APP_URL_REQUEST_MANAGEMENT}/request-management/criteria`,
      filters,
      headers
    )
      .then((response) => {
        if (response.data.result) {
          resolve(response);
        }
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        //reject(error.response);
        resolve(error.response);
      });
  });
};

export const filterApprovingCharge = (filters, paginador) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(
      `${APP_URL_CONTRACT}/employee/criteria/?page=${paginador.page}&size=${paginador.size}&order=${paginador.order}&columnOrder=${paginador.columnOrder}`,
      filters,
      headers
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

//PERSONA - permisos que ha tramitado el usuario en sesion
export const getFilterPermissions = (filters, paginator, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(
      `${APP_URL_REQUEST_MANAGEMENT}/request-management/criteria/?page=${paginator.page}&size=${paginator.size}&order=${paginator.order}&columnOrder=${paginator.columnOrder}`,
      filters,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        //reject(error.response);
        resolve(error.response);
      });
  });
};

//HR - todos los permisos por gestionar
export const getFilterPermissionsHr = (filters, paginator, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(
      `${APP_URL_REQUEST_MANAGEMENT}/request-management/criteria-hr/?page=${paginator.page}&size=${paginator.size}&order=${paginator.order}&columnOrder=${paginator.columnOrder}`,
      filters,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        /* dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        }); */
        //reject(error.response);
        resolve(error.response);
      });
  });
};

//APROBADOR - permisos en los cuales el usuario en sesion es aprobador
// "status": "PENDIENTE_POR_APROBACION",
export const getFilterPermissionApprover = (filters, paginator, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(
      `${APP_URL_REQUEST_MANAGEMENT}/request-management/criteria-user-approver/?page=${paginator.page}&size=${paginator.size}&order=${paginator.order}&columnOrder=${paginator.columnOrder}`,
      filters,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        /* dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        }); */
        //reject(error.response);
        resolve(error.response);
      });
  });
};

export const permissionsApprove = (body) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.put(`${APP_URL_REQUEST_MANAGEMENT}/request-management/approve/`, body, headers).then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

//Cancelar
export const permissionsCancel = (body, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.put(
      `${APP_URL_REQUEST_MANAGEMENT}/request-management/cancel/`,
      body,
      headers
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

//Pre Aprobar
export const permissionsPreApprove = (body) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.put(
      `${APP_URL_REQUEST_MANAGEMENT}/request-management/pre-approve/`,
      body,
      headers
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};
//Rechazar
export const permissionsReject = (body, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.put(
      `${APP_URL_REQUEST_MANAGEMENT}/request-management/reject/`,
      body,
      headers
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};
